export type PasswordStrengthLevel = 'empty' | 'weak' | 'medium' | 'strong'

const WEAK_PASSWORDS = new Set([
  '123456',
  '12345678',
  'password',
  'abcdef',
  'qwerty',
  '111111',
  '000000',
  'azerty',
  'abc123',
])

export function getPasswordStrength(password: string): PasswordStrengthLevel {
  if (!password) return 'empty'
  if (!validatePassword(password)) return 'weak'

  const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
  const hasUpper = /[A-Z]/.test(password)
  const hasLower = /[a-z]/.test(password)
  const hasNumber = /\d/.test(password)

  if (password.length >= 12 && hasUpper && hasLower && hasNumber && hasSpecial) {
    return 'strong'
  }
  if (password.length >= 10 && hasLower && hasNumber) {
    return 'medium'
  }
  return 'medium'
}

export default function validatePassword(password: string): boolean {
  if (password.length < 8) return false
  if (!/[a-zA-Z]/.test(password)) return false
  if (!/\d/.test(password)) return false
  if (WEAK_PASSWORDS.has(password.toLowerCase())) return false
  return true
}
